import { ApiServices } from "../../services/api_services";
import { COREURL } from "../../constants/api_constants";
import { CoreServices } from "../../base/service/apiServices";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAgentStatus = createAsyncThunk("users/getAgentStatus", async () => {
  return ApiServices.get(COREURL, `/get_agent_status_desc`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export const deleteAgentStatus = createAsyncThunk("users/deleteStatus", async (aid: any) => {
  return ApiServices.delete(COREURL, `/delete_agent_status/${aid}`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export const validateStatusName = createAsyncThunk("users/validateStatusName", async (data: any) => {
  return ApiServices.post(COREURL, `/is_valid_agent_status_name`, {
    name: data,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export const getAgentStatusDetails = createAsyncThunk("users/getAgentStatusDetails", async (id: any) => {
  return ApiServices.get(COREURL, `/get_agent_status_details/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export const insertAgentStatus = createAsyncThunk("users/insertAgentStatus", async (data: any) => {
  return ApiServices.post(COREURL, `/insert_agent_status`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export const updateAgentStatus = createAsyncThunk("users/updateAgentStatus", async (data: any) => {
  return ApiServices.put(COREURL, `/update_agent_status/${data.paramsid}`, data.params)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export const updateAgentState = createAsyncThunk("users/get_agent_status", async () => {
  return CoreServices.get("/get_agent_status")
    .then((response) => response)
    .catch((error) => error);
});
